// extracted by mini-css-extract-plugin
module.exports = {"dailyHeader":"A9hf","link":"A9ch","notFirst":"A9hh"};